import { Link } from 'react-router-dom';
import { ArrowLeft, Shield, CheckCircle, Clock, FileText, Star, AlertCircle } from 'lucide-react';

export default function SellerVerification() {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-4xl mx-auto px-4 py-8">
        <Link to="/" className="flex items-center gap-2 text-primary mb-6 hover:underline">
          <ArrowLeft className="w-5 h-5" />
          Volver al inicio
        </Link>

        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-primary/10 rounded-full mb-4">
            <Shield className="w-10 h-10 text-primary" />
          </div>
          <h1 className="text-3xl font-black mb-2">
            <span className="text-primary">Verificación de</span> Vendedores
          </h1>
          <p className="text-gray-600 max-w-2xl mx-auto">
            La verificación te ayuda a construir confianza con los compradores y aumenta tus ventas
          </p>
        </div>

        <div className="space-y-6">
          {/* Beneficios */}
          <div className="bg-white rounded-2xl shadow-lg p-6">
            <h2 className="text-xl font-bold mb-4 flex items-center gap-2">
              <Star className="w-6 h-6 text-primary" />
              Beneficios de estar verificado
            </h2>
            <div className="grid md:grid-cols-2 gap-4">
              <div className="flex items-start gap-3 p-4 bg-green-50 rounded-xl">
                <CheckCircle className="w-6 h-6 text-green-500 flex-shrink-0" />
                <div>
                  <p className="font-semibold text-gray-800">Mayor confianza</p>
                  <p className="text-sm text-gray-600">Los compradores confían más en vendedores verificados</p>
                </div>
              </div>
              <div className="flex items-start gap-3 p-4 bg-green-50 rounded-xl">
                <CheckCircle className="w-6 h-6 text-green-500 flex-shrink-0" />
                <div>
                  <p className="font-semibold text-gray-800">Mayor visibilidad</p>
                  <p className="text-sm text-gray-600">Apareces primero en los resultados de búsqueda</p>
                </div>
              </div>
              <div className="flex items-start gap-3 p-4 bg-green-50 rounded-xl">
                <CheckCircle className="w-6 h-6 text-green-500 flex-shrink-0" />
                <div>
                  <p className="font-semibold text-gray-800">Badge especial</p>
                  <p className="text-sm text-gray-600">Obtén una insignia de vendedor verificado</p>
                </div>
              </div>
              <div className="flex items-start gap-3 p-4 bg-green-50 rounded-xl">
                <CheckCircle className="w-6 h-6 text-green-500 flex-shrink-0" />
                <div>
                  <p className="font-semibold text-gray-800">Más ventas</p>
                  <p className="text-sm text-gray-600">Los vendedores verificados cierran más negocios</p>
                </div>
              </div>
            </div>
          </div>

          {/* Requisitos */}
          <div className="bg-white rounded-2xl shadow-lg p-6">
            <h2 className="text-xl font-bold mb-4 flex items-center gap-2">
              <FileText className="w-6 h-6 text-primary" />
              Requisitos para verificarte
            </h2>
            <div className="space-y-4">
              <div className="flex items-start gap-4 p-4 border-2 border-gray-200 rounded-xl">
                <div className="w-10 h-10 bg-primary/10 rounded-full flex items-center justify-center flex-shrink-0">
                  <span className="text-primary font-bold">1</span>
                </div>
                <div>
                  <p className="font-semibold text-gray-800">Cuenta activa</p>
                  <p className="text-sm text-gray-600">Debes tener una cuenta registrada en MotoMarket CR</p>
                </div>
              </div>
              <div className="flex items-start gap-4 p-4 border-2 border-gray-200 rounded-xl">
                <div className="w-10 h-10 bg-primary/10 rounded-full flex items-center justify-center flex-shrink-0">
                  <span className="text-primary font-bold">2</span>
                </div>
                <div>
                  <p className="font-semibold text-gray-800">Identificación oficial</p>
                  <p className="text-sm text-gray-600">Subir foto de ambos lados de tu cédula de identidad costarricense</p>
                </div>
              </div>
              <div className="flex items-start gap-4 p-4 border-2 border-gray-200 rounded-xl">
                <div className="w-10 h-10 bg-primary/10 rounded-full flex items-center justify-center flex-shrink-0">
                  <span className="text-primary font-bold">3</span>
                </div>
                <div>
                  <p className="font-semibold text-gray-800">Plan PRO o PREMIUM</p>
                  <p className="text-sm text-gray-600">La verificación está disponible para planes de pago (PRO o PREMIUM)</p>
                </div>
              </div>
              <div className="flex items-start gap-4 p-4 border-2 border-gray-200 rounded-xl">
                <div className="w-10 h-10 bg-primary/10 rounded-full flex items-center justify-center flex-shrink-0">
                  <span className="text-primary font-bold">4</span>
                </div>
                <div>
                  <p className="font-semibold text-gray-800">Revisión manual</p>
                  <p className="text-sm text-gray-600">Nuestro equipo revisará tu información en un máximo de 24-48 horas</p>
                </div>
              </div>
            </div>
          </div>

          {/* Proceso */}
          <div className="bg-primary/5 rounded-2xl p-6">
            <h2 className="text-xl font-bold mb-4 flex items-center gap-2">
              <Clock className="w-6 h-6 text-primary" />
              Proceso de verificación
            </h2>
            <div className="relative">
              <div className="absolute left-4 top-0 bottom-0 w-0.5 bg-primary/30"></div>
              <div className="space-y-6 relative">
                <div className="flex items-start gap-4 pl-8">
                  <div className="absolute -left-2 w-6 h-6 bg-white border-2 border-primary rounded-full flex items-center justify-center">
                    <div className="w-2 h-2 bg-primary rounded-full"></div>
                  </div>
                  <div>
                    <p className="font-semibold text-gray-800">1. Regístrate</p>
                    <p className="text-sm text-gray-600">Crea tu cuenta y selecciona el plan PRO o PREMIUM</p>
                  </div>
                </div>
                <div className="flex items-start gap-4 pl-8">
                  <div className="absolute -left-2 w-6 h-6 bg-white border-2 border-primary rounded-full flex items-center justify-center">
                    <div className="w-2 h-2 bg-primary rounded-full"></div>
                  </div>
                  <div>
                    <p className="font-semibold text-gray-800">2. Sube tu identificación</p>
                    <p className="text-sm text-gray-600">Ve a tu perfil y carga las fotos de tu cédula</p>
                  </div>
                </div>
                <div className="flex items-start gap-4 pl-8">
                  <div className="absolute -left-2 w-6 h-6 bg-white border-2 border-primary rounded-full flex items-center justify-center">
                    <div className="w-2 h-2 bg-primary rounded-full"></div>
                  </div>
                  <div>
                    <p className="font-semibold text-gray-800">3. Espera la revisión</p>
                    <p className="text-sm text-gray-600">Nuestro equipo revisará tu documento en 24-48 horas</p>
                  </div>
                </div>
                <div className="flex items-start gap-4 pl-8">
                  <div className="absolute -left-2 w-6 h-6 bg-white border-2 border-primary rounded-full flex items-center justify-center">
                    <div className="w-2 h-2 bg-primary rounded-full"></div>
                  </div>
                  <div>
                    <p className="font-semibold text-gray-800">4. ¡Listo!</p>
                    <p className="text-sm text-gray-600">Recibirás tu badge de vendedor verificado</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Nota importante */}
          <div className="bg-amber-50 border-2 border-amber-200 rounded-2xl p-6">
            <div className="flex items-start gap-3">
              <AlertCircle className="w-6 h-6 text-amber-600 flex-shrink-0" />
              <div>
                <p className="font-semibold text-amber-800">Nota importante</p>
                <p className="text-sm text-amber-700 mt-1">
                  Tu información personal está segura. Solo la usamos para verificar tu identidad y nunca la compartimos con terceros.
                </p>
              </div>
            </div>
          </div>

          {/* CTA */}
          <div className="bg-primary rounded-2xl shadow-lg p-8 text-center">
            <h2 className="text-2xl font-bold text-white mb-4">¿Listo para verificarte?</h2>
            <p className="text-white/80 mb-6">Regístrate ahora y obtén tu badge de vendedor verificado</p>
            <Link to="/register" className="inline-block bg-white text-primary font-bold px-8 py-3 rounded-xl hover:bg-gray-100 transition">
              Crear Cuenta
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
